import React from "react";
import { Link } from "react-router-dom";

import "./index.scss";

const Resume = () => {
  return (
    <div className="resume page">
      <div className="page__title">
        <h1>Resume</h1>
      </div>
      <div className="about__block resume__block">
        <div className="about__text item">
          <div>
          <p>Frontend / Full-Stack Developer with 6+ years of commercial experience in web development, specializing in React, TypeScript, JavaScript, and modern frontend architecture.</p>

<p>Strong experience building complex web applications from scratch, including both frontend and backend development. Experienced in working with Node.js, NestJS, Express, PostgreSQL, MongoDB, DynamoDB, Firebase, and REST APIs.
  </p>

<p>Worked on products independently across the full development cycle, from architecture and implementation to integration and testing</p>
          </div>
        </div>
        <div className="about__info item">
          <div className="items info__list">
            {/* <div className="info__listItem"><span>Age</span>28</div> */}
            <div className="info__listItem">
              <span>Country</span>Ukraine
            </div>
            <div className="info__listItem">
              <span>e-mail</span>duminskiy@gmail.com
            </div>
            <div className="info__listItem">
              <span>Phone</span>+38 066 955-23-46
            </div>
          </div>
        </div>
      </div>

      <div className="items resume__block">
        {/* <h4>Frontend:</h4> */}
        <h2>Professional skills:</h2>
        <ul>
          <li>JavaScript (ES6+), TypeScript</li>
          <li>React, hooks, React-router</li>
          <li>Redux, Redux Saga, Redux Thunk, Reselect, redux-form</li>
          <li>Mobx</li>
          <li>VueJS</li>
          <li>SCSS / LESS / Stylus / PostCSS / styled-components</li>
          <li>Material UI, Twitter Bootstrap, Ant Design</li>
          <li>Webpack / Gulp </li>
          <li>Git / GitHub</li>
          <li>Node.JS / Express / MongoDB / Mongoose / JWT</li>
          {/* <li>PHP / Laravel</li> */}
        </ul>
      </div>
      <div className="resume__block">
        <h2>Experience</h2>
        <div
          style={{
            paddingBottom: "20px",
            borderBottom: "1px solid #666",
            marginBottom: "38px",
          }}
        >
          <h5 className="resume__subTitle">Visartech</h5>
          <div>05.2022 - now</div>
          <div>Front-end(fullstack) Developer </div>
          <h6 className="resume__res">Projects:</h6>
          <div>1. Metaverse 1(Backend, FrontEnd)</div>
          <div>
            <div>
              Backend(Express, PostgresQL, Sequelize, TS, DynamoDB, firebase)
            </div>
            <div>
              FrontEnd(React, Redux Toolkit, React hook form, firebase, Material
              UI), Unity
            </div>
          </div>
          <div>
            <div>2. Metaverse 2(FrontEnd, Backend)</div> Backend(NestJs,
            PostgresQL, TypeORM, DynamoDB, firebase) FrontEnd(React, Redux
            Toolkit, React hook form, firebase, Material UI), Unity
          </div>
          <div>
            <div>3. IELTS(FrontEnd, Backend)</div> Backend(ExpressJs, PostgesQL,
            Sequelize, Typescript, firebase)
            <div>
              FrontEnd(React, React Query, TS, React hook form, firebase,
              Material UI)
            </div>
          </div>
          <div>
            <div>4. DG</div>Contentfull
          </div>
          <h6 className="resume__res">Technologies:</h6>
          <ul>
            <li>JavaScript, Typescript.</li>
            <li>Node.js, Nest.js, Express, Sequelize, TypeORM;</li>
            <li>React JS, React hook form, Redux-toolkit, react query;</li>
            <li>Material UI</li>
            <li>PostgreSQL, Mongo DB, Dynamo DB,Firebase;</li>
            <li>Rest API;</li>
            <li>Git (GitHub, GitLab, Bitbucket);</li>
            <li>AWS</li>
          </ul>
          {/* <p>JavaScript · ReactJS · NodeJS · Redux · ReactRouter</p> */}
        </div>

        <div
          style={{
            paddingBottom: "20px",
            borderBottom: "1px solid #666",
            marginBottom: "38px",
          }}
        >
          <h5 className="resume__subTitle">Affiliate Marketing</h5>
          <div>Front-end developer (Vue/React)</div>
          <div>11.2021 - 03.2022</div>

          <h6 className="resume__res">Projects:</h6>
          <div>CRM(Vue / Vuex / Vetifyjs) </div>
          <div>React</div>
        </div>
        <div
          style={{
            paddingBottom: "20px",
            borderBottom: "1px solid #666",
            marginBottom: "38px",
          }}
        >
          <h5 className="resume__subTitle">Dila, Kyiv</h5>
          <div>Front-end developer (React)</div>
          <div>05.2021 - 09.2021</div>

          <h6 className="resume__res">Technologies:</h6>
          <div>React, TypeScript, MobX, NestJs, Material</div>
        </div>

        <div
          style={{
            paddingBottom: "20px",
            borderBottom: "1px solid #666",
            marginBottom: "38px",
          }}
        >
          <h5 className="resume__subTitle">Freelance Jobs</h5>
          <div>ReactJS Developer </div>

          <h6 className="resume__res">Responsibilities:</h6>
          <ul>
            <li>JavaScript, Typescript.</li>
            <li>
              Worked in using React JS components, Forms, Events, Keys, Router,
              Animations and Flux concept.
            </li>
            <li>
              Maintained states in the stores and dispatched the actions using
              redux.
            </li>
            <li>
              Component for UX-Library consisted of Button, Checkbox, Input,
              Icons, Toggle Button, Dropdown, Multi-Level Dropdown and many
              more.
            </li>
            <li>
              Created and used Reducers that received said Actions to modify the
              Store State Tree.
            </li>
            <li>
              Called the Restful web services calls for POST, PUT, DELETE and
              GET methods.
            </li>
          </ul>

          <p>JavaScript · ReactJS · NodeJS · Redux · ReactRouter</p>
        </div>

        <div>
          <h5 className="resume__subTitle">Dum Agency</h5>
          <div>Front End Developer / 2017 — 2019</div>
          <div>Kyiv, Ukraine</div>

          <p>React, TypeScript, MobX, NestJs, Material</p>
        </div>
      </div>

      <div className="resume__block">
        <h2>Education</h2>
        <div>
          <h5 className="resume__subTitle">
            Bachelor of Science, The Department of Programming Engineering
          </h5>
          <div>Zhytomyr Polytechnic State University | 2009 - 2013</div>

          <div>Ukraine</div>
        </div>
      </div>
    </div>
  );
};

export default Resume;
